<template>
  <div class="p-3 md:p-6 bg-coldgray-50 border-round-2xl"><slot /></div>
</template>
<script setup lang="ts"></script>
